import type { IconName } from '@fortawesome/fontawesome-svg-core';
import type { Theme } from '@mui/material/styles';

import * as SURVEYS from '@constants/survey-ids';

// import { ImageType } from '@models/ImageType';

export function resolveIcon(
  surveyId: string,
  theme: Theme
): { iconName: IconName; iconColor: string } | null {
  const HEALTH_ICON_COLOR = theme.palette.primary.main;
  if (surveyId.includes('vital-sign---')) {
    return { iconName: 'monitor-waveform', iconColor: HEALTH_ICON_COLOR };
  }

  if (surveyId.includes('labs_')) {
    return { iconName: 'vials', iconColor: HEALTH_ICON_COLOR };
  }

  switch (surveyId) {
    case SURVEYS.ALLERGY_ID:
      return { iconName: 'hand-dots', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.APPOINTMENTS_ID:
      return {
        iconName: 'calendar-days',
        iconColor: HEALTH_ICON_COLOR,
      };
    case SURVEYS.EMERGENCY_VISIT_ID:
      return {
        iconName: 'truck-medical',
        iconColor: HEALTH_ICON_COLOR,
      };
    case SURVEYS.FAMILY_HISTORY_ID:
      return { iconName: 'users', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.CARRIER_STATUS_ID:
    case SURVEYS.HEALTH_RISK_ID:
      return { iconName: 'dna', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.HOSPITALIZATION_ID:
      return {
        iconName: 'hospital-wide',
        iconColor: HEALTH_ICON_COLOR,
      };
    case SURVEYS.IMAGING_TESTS_ID:
      return { iconName: 'images', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.IMMUNIZATION_ID:
      return { iconName: 'syringe', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.MEDICAL_CONDITION_ID:
      return { iconName: 'stethoscope', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.MEDICATION_ID:
      return { iconName: 'capsules', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.SURGERY_ID:
      return {
        iconName: 'scalpel-line-dashed',
        iconColor: HEALTH_ICON_COLOR,
      };
    case SURVEYS.VITAL_SIGN_ID:
      return { iconName: 'monitor-waveform', iconColor: HEALTH_ICON_COLOR };
    case SURVEYS.LAB_RESULTS_ID:
      return { iconName: 'vials', iconColor: HEALTH_ICON_COLOR };
    default:
      return null;
  }
}
